import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.723 41.651 7.81 3.723 3.763-3.237h3.408l3.768 3.232 7.81-3.723-.06-5.069 1.66-2.289 5.355-.972L46 24.858l-4.425-2.731L41 18.914l2.795-4.46-5.703-7.092-5.295 1.542-2.362-1.233L28.514 3h-9.038l-1.925 4.671-2.363 1.238-5.29-1.547-5.702 7.092 2.794 4.46-.574 3.213L2 24.867l1.768 8.458 5.354.973 1.66 2.289-.059 5.064Zm15.522-.982h-4.5l-3.448 2.971-6.09-2.907.049-4.613-2.299-3.163-4.96-.904-1.352-6.473 4.102-2.545.79-4.42-2.539-4.057 4.426-5.507 4.917 1.44 3.364-1.759 1.754-4.258h7.073l1.748 4.253 3.365 1.754 4.916-1.435 4.426 5.511-2.54 4.058.791 4.42 4.112 2.535-1.351 6.474-4.961.903-2.299 3.163.05 4.618-6.091 2.907-3.453-2.966Zm-2.25-8.512c-4.435 0-8.04-3.606-8.04-8.041 0-4.435 3.605-8.04 8.04-8.04 4.436 0 8.04 3.605 8.04 8.04 0 4.435-3.604 8.04-8.04 8.04Zm-6.567-8.041a6.576 6.576 0 0 1 6.567-6.567 6.576 6.576 0 0 1 6.567 6.567 6.576 6.576 0 0 1-6.567 6.567 6.576 6.576 0 0 1-6.567-6.567Z",
    fill: "currentColor"
  }));
};

var SvgSettings1 = styled(SvgComponent).withConfig({
  displayName: "Settings1__SvgSettings1",
  componentId: "sc-w8e8nl-0"
})(["", " ", ""], size, color);
export default SvgSettings1;